import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tracks in-app navigations (pathname changes) and returns `true` for a
 * brief settle window after each one — used to show the full-screen
 * branded loading animation (same visual as LogoutOverlay/BrandedLoader)
 * during tab/page switches instead of a fake decorative progress bar.
 *
 * - First mount does NOT trigger it (no flash on initial load).
 * - Re-clicking the same route (same pathname) is a no-op.
 */
export default function useRouteTransition(settleMs = 350) {
  const { pathname } = useLocation();
  const lastPathRef = useRef(pathname);
  const initialRef = useRef(true);
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    if (initialRef.current) {
      initialRef.current = false;
      lastPathRef.current = pathname;
      return undefined;
    }
    if (lastPathRef.current === pathname) return undefined;
    lastPathRef.current = pathname;

    setNavigating(true);
    const t = setTimeout(() => setNavigating(false), settleMs);
    return () => clearTimeout(t);
  }, [pathname, settleMs]);

  return navigating;
}
